import { useEffect } from "react";
import { ADD_ITEM_PROGRESS_CHANNEL } from "../../components/addItem/AddItemUtils";

/**
 * Revalidates an SWR key when a sync finishes.
 *
 * The usage endpoints are the reason this exists: the add-item flow runs in the
 * item view while the charts and the detailed table render elsewhere, the socket
 * success handler only refreshes item locations, and nothing else calls their
 * `mutate` — so a fresh account kept reporting the pre-sync numbers. The sync
 * commits its rows before the success message is sent, so this is the earliest
 * point a refetch returns the new counts. BroadcastChannel crosses the iframes.
 */
const useRevalidateOnAddItemCompleted = (revalidate: () => void) => {
  useEffect(() => {
    let channel: BroadcastChannel;
    try {
      channel = new BroadcastChannel(ADD_ITEM_PROGRESS_CHANNEL);
    } catch {
      return; // BroadcastChannel not supported
    }

    channel.onmessage = (event: MessageEvent<{ type: string }>) => {
      if (event.data?.type === "add-item-completed") revalidate();
    };

    return () => channel.close();
  }, [revalidate]);
};

export default useRevalidateOnAddItemCompleted;
